import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../Icon';
import { trackEvent } from '../../utils/analytics';
import { PHONE } from '../../content/contacts';
import { tie } from '../page/typography';

/**
 * «Чим ми можемо допомогти» — заклик наприкінці статті.
 *
 * Раніше ці три пункти стояли блідою рамкою посеред статті, без жодної
 * кнопки, а нижче йшов ще й загальний банер «Обговоримо вашу ситуацію».
 * Людина, яка дочитала про пропущений строк, бачила спершу перелік послуг
 * без дії, а потім дію без конкретики. Тепер це одне: що саме ми зробимо —
 * і як до цього дійти. Тому загального банера під статтею немає.
 *
 * Той самий градієнт, що й у заклику решти сторінок: стаття закінчується
 * так само, як інші сторінки сайту, тільки з власним змістом.
 */
const ArticleHelp = ({ id = 'dopomoga', title, actions = [], source = 'blog-article' }) => (
  <section aria-labelledby={`${id}-title`} className="page-container pb-16 lg:pb-24">
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-teal-700 to-sky-700 p-6 sm:p-8 lg:p-10 text-white shadow-md">
      <div className="absolute -top-10 -right-10 w-40 h-40 bg-white/10 rounded-full blur-3xl pointer-events-none" aria-hidden="true"></div>

      <div className="relative grid gap-8 lg:grid-cols-[minmax(0,1fr)_auto] lg:gap-14 lg:items-center">
        <div>
          <h2 id={`${id}-title`} className="text-2xl lg:text-3xl font-black font-display text-balance">
            {tie(title)}
          </h2>
          <ul className="list-none m-0 p-0 mt-5 space-y-3">
            {actions.map((action) => (
              <li key={action} className="flex items-start gap-3">
                <span
                  className="mt-0.5 flex-shrink-0 w-6 h-6 rounded-full bg-white/15 flex items-center justify-center"
                  aria-hidden="true"
                >
                  <Icon name="fa-check" className="text-xs" />
                </span>
                <span className="text-base lg:text-lg leading-relaxed text-white">{tie(action)}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* На телефоні кнопки на всю ширину одна під одною: так у них легко
            влучити пальцем, і номер не рветься посередині. */}
        <div className="flex flex-col sm:flex-row lg:flex-col gap-3 lg:gap-4">
          <Link
            to="/kontakty"
            onClick={() => trackEvent('cta_click', source)}
            className="inline-flex items-center justify-center gap-3 rounded-lg bg-white px-6 py-3 font-bold text-teal-700 hover:bg-teal-50 transition-colors duration-200 whitespace-nowrap focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-teal-700"
          >
            Отримати консультацію
            <Icon name="fa-arrow-right" />
          </Link>
          <a
            href={PHONE.href}
            onClick={() => trackEvent('contact_channel', `${source}-phone`)}
            className="inline-flex items-center justify-center gap-3 rounded-lg border border-white/60 px-6 py-3 font-bold text-white hover:bg-white/10 transition-colors duration-200 whitespace-nowrap focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-teal-700"
          >
            <Icon name="fa-phone" />
            {PHONE.label}
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default ArticleHelp;
